<template>
  <div :class="wrapperClass">
    <section class="h-full bg-gray-5">
      <BtnSideBar
        v-for="menuItem in MAIN"
        :key="menuItem.to"
        :label="menuItem.text"
        :active="menu[1] === menuItem.to.split('/')[1]"
        @click="updateMenu(menuItem.to.split('/')[1])"
      />
    </section>

    <section
      v-if="secondLinks.length > 0"
      class="px-8 divide-y divide-gray-20 overflow-y-auto h-full"
    >
      <AccordionSideBar
        v-for="(section, index) in secondLinks"
        :key="index"
        :title="{ text: section.text, to: section.to }"
        :menuList="
          section.children
            ? section.children.map((child) => ({ text: child.text, to: child.to }))
            : []
        "
        @click="moveTo"
      />
    </section>
  </div>
</template>

<script setup lang="ts">
import BtnSideBar from '../button/BtnSideBar.vue'
import AccordionSideBar from '../accordion/AccordionSideBar.vue'
import { ref, onMounted, computed, watch } from 'vue'
import {
  getMainLinks,
  getDeviceLinks,
  getDemoLinks,
  getProjectLinks,
  getAILinks,
  getUsecaseLinks
} from '@/app/router/navigation'
import { useRoute, useRouter } from 'vue-router'
import { safe } from '@/shared/lib/safe'

type Props = {
  isOpen: boolean
}
const props = defineProps<Props>()
props.isOpen

const emit = defineEmits(['close'])

const menu = ref<string[]>([])
const secondLinks = computed<RouteLink[]>(() => {
  return SECTION_CHILDREN[menu.value[1]] || []
})

const MAIN = safe(getMainLinks, [])
const SECTION_CHILDREN: Record<string, RouteLink[]> = {
  devices: safe(getDeviceLinks, []),
  demo: safe(getDemoLinks, []),
  projects: safe(getProjectLinks, []),
  ai: safe(getAILinks, []),
  usecase: safe(getUsecaseLinks, [])
}

const route = useRoute()
const router = useRouter()

watch(
  () => route.path,
  () => {
    menu.value = getCategoryFromRoute()
  }
)

onMounted(() => {
  menu.value = getCategoryFromRoute()
  if (!menu.value[1]) {
    menu.value[1] = 'devices'
  }
})

const updateMenu = (name: string) => {
  menu.value[1] = name
}

const moveTo = (to: string) => {
  router.push(to)
  handleClose()
}

const handleClose = () => {
  emit('close')
}

function getCategoryFromRoute() {
  const path = route.path
  const category = path.split('/')
  return category
}

const wrapperClass = computed(() => {
  const base =
    'fixed top-28 w-full h-[calc(100vh-56px)] z-[10001] transition-3 bg-white grid grid-cols-[1fr_2fr]'
  const openClass = props.isOpen ? 'left-0' : 'left-[calc(-100%)]'
  return [base, openClass].join(' ')
})
</script>
